import {formatDate} from "../../commons/commons";
import {JSX} from "wfr/commons/jsx"
import {ENavLanguages, JDownloadProductSource, L10nLabels} from "../../commons/api";
import {DownloadProductComponent, familyMembers, urltree} from "./product";
import {lang} from "../../commons/language-selector";
import {ETileTitle, ProductTile} from "../product-tile";
import {sort} from "../commons";

export {FamilyBox}

const	labels:L10nLabels = {
	[ENavLanguages.fr]: {
		altLogo:"logo"
	},
	[ENavLanguages.en]: {
		altLogo:"logo"
	}
}


class FamilyBox extends DownloadProductComponent {
	protected members:JDownloadProductSource[]
	protected labels = labels

	loadData() {
		super.loadData();
		this.members = Object.values(familyMembers).sort(sort)
	}

	rebuild() {
		if(!super.rebuild()) return false
		this.shadowRoot.append(<ul>
			{this.members.map(metas=> {
				return <li>{new ProductTile(metas, urltree, {title:ETileTitle.short, addClassName:"tile", fullDatedVersion:true})}</li>
			})}
		</ul>)
		return true
	}
}
customElements.define('family-box', FamilyBox)